import { useSelector } from "react-redux";
import { ReferralCode } from "./referralCode";
import { FavoriteLocation } from "@/components/account/accountInformation/favoriteLocation";
import {
  StyledCheckoutComponent,
  StyledHeaderText,
  StyledStepHeader,
} from "@/components/checkout/uielements";
import { StyledBorderBottom } from "@/components/uielements/reward/styles";
import { SIGNUP_OPTIONAL_FIELDS } from "@/constants/authentication";
import { useWebConfig } from "@/redux/cmsConfig";
import { organizationSliceSelector } from "@/redux/organization/reducer";
import { getSignupOptionalFields } from "@/utils/auth";

const containerId = "account-information-container";
const headerContainerId = "account-information-header-container";

export const AccountInformation = () => {
  const webConfig = useWebConfig();
  const organization = useSelector(organizationSliceSelector);
  const isFavoriteLocationEnabled =
    webConfig.accounts.favorite_location !== "disabled";
  const organizationConsentFields = getSignupOptionalFields(
    organization?.organization?.loyalty_driver_id
  );
  const referralCodeEnabled =
    webConfig.accounts.punchh_referral_code_field &&
    organizationConsentFields.includes(SIGNUP_OPTIONAL_FIELDS.REFERRAL_CODE);

  if (!referralCodeEnabled && !isFavoriteLocationEnabled) {
    return null;
  }

  return (
    <StyledCheckoutComponent data-testid={containerId}>
      <StyledStepHeader data-testid={headerContainerId} enabled={true}>
        <StyledHeaderText>Account Information</StyledHeaderText>
      </StyledStepHeader>

      {/* Referral Code Section */}
      {referralCodeEnabled && <ReferralCode />}

      <StyledBorderBottom />

      {/* Favorite Location Section */}
      <FavoriteLocation />
    </StyledCheckoutComponent>
  );
};
